<template>
    <div>
        <!-- Breadcrumb Start-->
        <div class="section-breadcrumb">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 justify-content-center align-self-center pb-2">
                        <ul class="breadcrumb-link text-center list-unstyled mb-0">
                            <li class="text-white"><a href="#">Home</a></li>
                            <li class="text-white"><a href="#">Pages</a></li>
                            <li class="text-white active">Register</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- Breadcrumb End -->
        <!-- Start Register -->
        <section class="section">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-6">
                        <form class="contact_form common_form mt-3 pt-3">
                            <div>
                                <h1 class="font-weight-bold text-center">Register</h1>
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="form-group">
                                        <i class="login-icon mdi mdi-account"></i>
                                        <input name="username" id="username" type="text" class="form-control" placeholder="User name...">
                                    </div>
                                </div>
                                <div class="col-lg-12">
                                    <div class="form-group">
                                        <i class="login-icon mdi mdi-email"></i>
                                        <input name="email" id="email" type="email" class="form-control" placeholder="Email...">
                                    </div>
                                </div>
                                <div class="col-lg-12">
                                    <div class="form-group">
                                        <i class="login-icon mdi mdi-cellphone"></i>
                                        <input name="mobile" id="mobile" type="number" class="form-control" placeholder="Mobile Number...">
                                    </div>
                                </div>
                                <div class="col-lg-12">
                                    <div class="form-group">
                                        <i class="login-icon mdi mdi-lock"></i>
                                        <input name="password" id="password" type="password" class="form-control" placeholder="Password...">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-3">
                                    <div class="form-group">
                                        <div class="custom-control custom-radio">
                                            <input type="radio" id="customRadio1" name="customRadio" class="custom-control-input">
                                            <label class="custom-control-label" for="customRadio1">Male</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="form-group">
                                        <div class="custom-control custom-radio">
                                            <input type="radio" id="customRadio2" name="customRadio" class="custom-control-input">
                                            <label class="custom-control-label" for="customRadio2">Female</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="form-group">
                                        <div class="custom-control custom-checkbox">
                                            <input type="checkbox" class="custom-control-input" id="rememberme">
                                            <label class="custom-control-label text-2" for="rememberme">I have read and agree to the<a href="#"> terms of service</a> </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12 text-center">
                                    <input type="submit" class="btn btn-gradient text-white w-100 text-uppercase" value="Register">
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
        <!-- End Register -->
    </div>
</template>
<script>
    export default {
        name: "register",
        mounted() {
            this.init();
        },
        methods: {
            init() {
                this.hidePreloader();
            },

            /*----PRELOADER-----*/
            hidePreloader() {
                var preloaderFadeOutTime = 500;
                var preloader = $('.spinner-wrapper');
                setTimeout(function () {
                    preloader.fadeOut(preloaderFadeOutTime);
                }, 500);
            }

        }
    }</script>
